import styled from 'styled-components';

import { GRAY, PRIMARY } from 'constants/colors';

import { rSize } from 'components/utils';
import { brightness } from 'utils/misc';

import { FIRST_CELL_WIDTH } from '../const';

const RosterViewByEmployee = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${rSize(30)};
  box-sizing: border-box;

  h3 {
    margin-top: 0;
  }

  .roster-grid {
    table-layout: fixed;

    th,
    td {
      border: 0;
      padding: 2px;
      vertical-align: top;
      position: relative;
      text-align: center;
      box-sizing: border-box;
    }

    th {
      padding: 8px;
      line-height: 20px;
      white-space: nowrap;
    }

    td {
      border: 1px dashed #ccc;
      height: 49px;

      &:first-child {
        border-left: 0;
      }
      &:last-child {
        border-right: 0;
      }
    }

    tr:not(:first-child) {
      td:not(:last-child):not(:first-child)::after,
      td:nth-child(2)::before {
        content: '';
        position: absolute;
        z-index: 2;
        width: 6px;
        height: 6px;
        right: 0;
        top: 0;
        transform: translate(50%, -50%);
        background-color: white;
      }
      td:nth-child(2)::before {
        right: auto;
        left: 0;
        transform: translate(-50%, -50%);
      }
    }

    thead tr:first-child th:first-child,
    td:first-child {
      width: ${FIRST_CELL_WIDTH};
      text-align: left;
      padding-bottom: 0;
    }

    thead {
      tr:last-child th {
        padding: 5px 0px;
      }
    }

    tr {
      &:first-child {
        td {
          border-top: 0;
        }
      }

      &:last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    .is-sunday:not(:last-child) {
      border-right: 1px dashed ${PRIMARY};

      &::before,
      &::after {
        display: none;
      }
    }

    tbody {
      tr {
        &:first-child td {
          padding-top: 0;
        }

        &:last-child td {
          padding-bottom: 0;
        }
      }
      td {
        &:first-child {
          padding-left: 12px;
        }
        &:last-child {
          padding-right: 0;
        }
      }
      tr:not(.no-highlight) {
        td {
          transition: background-color 0.15s ease-in-out 0.1s;
        }

        &:hover {
          td {
            background-color: ${brightness(PRIMARY, 90)};
          }
        }
      }
    }

    .display-contents:last-child {
      .duty,
      .absence {
        margin-bottom: 0;
      }
    }

    .function-container {
      position: relative;
      line-height: 20px;

      .function-color {
        position: absolute;
        left: -10px;
        top: 0;
        height: 100%;
        display: flex;
        align-items: center;

        svg {
          width: 6px;
          height: 6px;
        }
      }
    }

    .is-weekend {
      background-color: ${brightness(GRAY, 85)};
    }

    .is-today {
      background-color: ${brightness(PRIMARY, 90)};
    }

    .is-yesterday,
    .is-today,
    .is-friday,
    .is-weekend {
      &::before,
      &::after {
        display: none;
      }
    }
  }

  .MuiAccordionSummary-root {
    width: ${FIRST_CELL_WIDTH};
    padding-right: calc(100% - ${FIRST_CELL_WIDTH}) !important;
    padding-left: 0 !important;
    justify-content: center !important;
  }

  .roster-body {
    position: relative;
    flex-grow: 1;

    .wrap-container {
      display: block;
      padding-right: 16px;
    }
  }

  &:not(.is-accordion) {
    .header {
      margin-bottom: 10px;
    }
    .employees-container:not(:last-child) {
      margin-bottom: 10px;
    }

    .open-requests-container {
      margin-top: 10px;
    }
  }

  .search {
    .MuiInput-root {
      margin-top: 15px;
    }
  }
`;

export default RosterViewByEmployee;
